const updates = [
  { id: 1, date: '07-29', time: '2小时前', title: '《海贼王》第1128话更新：艾尔巴夫篇进入新阶段', tag: '热门' },
  { id: 2, date: '07-29', time: '5小时前', title: '《咒术回战》第271话：最终决战迎来惊天反转', tag: '爆' },
  { id: 3, date: '07-28', time: '昨天', title: '《电锯人》第二部第183话：全新角色登场引发热议', tag: '新' },
  { id: 4, date: '07-28', time: '昨天', title: '《坂本日常》第195话：杀联考试篇章高潮迭起', tag: '热' },
  { id: 5, date: '07-27', time: '2天前', title: '《间谍过家家》第103话：安尼亚的新任务笑翻全网', tag: '' },
  { id: 6, date: '07-27', time: '2天前', title: 'Jump新连载《极乐街》首话评价出炉，口碑超预期', tag: '新番' },
  { id: 7, date: '07-26', time: '3天前', title: '《葬送的芙莉莲》第137话：精灵的回忆篇章催泪收官', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            实时追踪
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm mt-2">热门日漫连载更新一手掌握</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={item.id} className="relative flex gap-4 pb-6 group">
              {idx < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300"></div>
              )}

              <div className="flex-shrink-0 w-10 flex flex-col items-center">
                <div className={`w-[10px] h-[10px] rounded-full mt-2 ${
                  idx === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-background-400'
                }`}></div>
              </div>

              <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-background-300 cursor-pointer transition-all">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  {item.tag && (
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '新' || item.tag === '新番' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '热' || item.tag === '热门' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-500'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <h3 className="text-sm font-medium text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}